import React, { useCallback } from 'react';
import { BorderAlignmentTypes, type ShapeElement } from '@bynder-studio/render-core';
import BorderWeightAlignment from '../../BorderWeightAlignment';

type Props = {
    disabled: boolean;
    selectedElement: ShapeElement;
    creativeModel: any;
};

const ShapeBorderWeight = ({ disabled, selectedElement, creativeModel }: Props) => {
    const id = selectedElement.id;

    const handleBorderWidthChange = useCallback(
        (borderWidth: number) => {
            creativeModel.updateElement(id, { borderWidth });
        },
        [creativeModel, id],
    );

    const handleBorderAlignmentChange = useCallback(
        (borderAlignment: BorderAlignmentTypes) => {
            creativeModel.updateElement(id, { borderAlignment });
        },
        [creativeModel, id],
    );

    return (
        <BorderWeightAlignment
            key={selectedElement.id}
            isDisabled={selectedElement.locked || disabled}
            defaultBorderWidth={selectedElement.borderWidth}
            defaultBorderAlignment={selectedElement.borderAlignment}
            onBorderWidthChange={handleBorderWidthChange}
            onBorderAlignmentChange={handleBorderAlignmentChange}
        />
    );
};

export default ShapeBorderWeight;
